import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Form } from '@bca-shared/models/form';
import { IUser } from '@bca-shared/models/user';
import { UIService } from '@bca-core/services/ui.service';

@Component({
  selector: 'bca-middle-name',
  templateUrl: 'middle-name.component.html',
  styleUrls: ['middle-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MiddleNameComponent extends Form<IUser> implements OnInit {
  @Input()
  userForm: FormGroup;
  @Input()
  middleNames: string[] = [];

  constructor(public _uiService: UIService) {
    super();
  }

  ngOnInit(): void {
    this.setFormGroup(this.userForm);
    const { formGroup } = this;
    formGroup.get('middleName').setValidators((control: FormControl) => {
      const { value } = control;
      if (!value) return null;

      return this.middleNames.includes(value.trim()) ? null : { middleName: true };
    });
  }
}
